import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'

import MyQuizTemplateCreateForm from './MyQuizTemplateCreateForm'
import MyQuizTemplateCreateTasks from './MyQuizTemplateCreateTasks'
import MyQuizTemplateCreatePreview from './MyQuizTemplateCreatePreview'

import { getQuiz, resetQuiz } from '../../../../../../routing/fetchingfunction/quiz/quiz.actions'
import { selectQuiz } from '../../../../../../routing/fetchingfunction/quiz/quiz.reducer'

const MyQuizTemplatesAdd = () => {
  const dispatch = useDispatch()
  const params = useParams()

  const quiz = useSelector(selectQuiz)

  const [step, setStep] = useState(1)
  const [quizTemplateData, setQuizTemplateData] = useState(null)

  const getTitle = () => {
    if (step === 1) {
      return quiz ? 'Edit Template' : 'Create New Template'
    }

    if (step === 2) {
      return quiz ? 'Edit Tasks' : 'Create Tasks'
    }

    if (step === 3) {
      return 'Quiz Preview'
    }

    return ''
  }

  const getContent = () => {
    if (step === 1) {
      return (
        <MyQuizTemplateCreateForm
          setStep={setStep}
          setQuizTemplateData={setQuizTemplateData}
          quizTemplateData={quizTemplateData}
        />
      )
    }

    if (step === 2) {
      return (
        <MyQuizTemplateCreateTasks
          quiz={quiz}
          setStep={setStep}
          setQuizTemplateData={setQuizTemplateData}
          quizTemplateData={quizTemplateData}
        />
      )
    }

    if (step === 3) {
      return (
        <MyQuizTemplateCreatePreview
          quiz={quiz}
          setStep={setStep}
          setQuizTemplateData={setQuizTemplateData}
          quizTemplateData={quizTemplateData}
        />
      )
    }
  }

  useEffect(() => {
    if (params.id) {
      dispatch(getQuiz(params.id))
    }
  }, [params])

  useEffect(() => {
    if (quiz) {
      setQuizTemplateData(quiz)
    }
  }, [quiz])

  useEffect(() => {
    return () => {
      dispatch(resetQuiz())
    }
  }, [])

  return (
    <div className="py-[64px] px-[148px] max-w-[800px] w-full bg-[#FEEBDD] rounded-[10px] shadow-modal mx-auto">
      <h1 className="text-3xl font-semibold text-primary-100 text-center mb-[24px]">
        {getTitle()} {step > 2 ? '' : `(${step}/2)`}
      </h1>

      {getContent()}
    </div>
  )
}

export default MyQuizTemplatesAdd
